import { ElementRef } from '@angular/core';
import { AfterViewInit, Component, ViewChild, OnInit } from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import * as xlsx from 'xlsx';
import { Router } from '@angular/router';
import { APIService } from 'src/app/api.service';
import { CommonService } from 'src/app/services/common.service';
import { Observable, Subject } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-rpt-prd-rejection-analysis',
  templateUrl: './rpt-prd-rejection-analysis.component.html',
  styleUrls: ['./rpt-prd-rejection-analysis.component.scss']
})

export class RptPrdRejectionAnalysisComponent implements AfterViewInit, OnInit {


displayedColumns: string[] = ['RejectionType','JobsImpected','Share'];

 dataSource = new MatTableDataSource();


  curDate: any = new Date();
  months: any = [];
  monthDisplay: any = [];
  IsPrevios = 0;
  agencyData: any;
  jarvisData: any;
  type:any =  "MM";
  month = this.curDate.getMonth();
  year = this.curDate.getFullYear();
  rejectionAnaData: any;
  tagData: any= [];
  categories: any;
  subCat: any;
  fromDate: any;
  toDate: any;
  ERP_Agn: any = [];
  accountDate: any = [];
  selectedFY: any;
  financialYears: any = [];
  exportToExcel: any = [];
  display: string = '';
  fromMinDate: any;
  selectedDate: any;
  acctStartDT: Date = new Date();
  sum = 0;

  
  @ViewChild('csttable', { static: false }) csttable!: ElementRef;
  //acctStartDT!: Date;
  selectedMonthName: any;
  item: any = [];
  getFullYear: any;
  filter: any;
  
  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }

  @ViewChild(MatPaginator) 
  set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  } 
  
  button: boolean = false;
  period = 0;

  constructor(private router: Router,  private commonService: CommonService, private apiService: APIService, private SpinnerService: NgxSpinnerService) { }
    view = {
      month: (this.curDate.getMonth() + 1).toString(),
      year: (this.curDate.getFullYear()).toString(),
      fy : '',
    }

  ngOnInit(): void {
    
    this.months = this.commonService.getMonthYear(new Date('2020-10-01').customFormat("#DD#-#MMM#-#YY#"), new Date().customFormat("#DD#-#MMM#-#YY#"));
    this.months = this.months.reverse();
    this.monthDisplay = this.months[0].display;
    // this.months = this.months.sort();
    // this.monthDisplay = this.months[this.months.length - 1].display;
  
    
    this.financialYears = this.commonService.checkFinancialYear(new Date('2019-Apr-01'), new Date());

    let tmpERP_Agn = this.apiService.getCookie("ERP_Agn");
    if (tmpERP_Agn) {
      this.ERP_Agn = JSON.parse(tmpERP_Agn);
    }
    this.typeFilter(1);
  }

  trasYearChange() {
    let selecetdYear = this.months.filter((a: any) => a.display == this.monthDisplay);
    this.view.year = selecetdYear[0].year;
    this.view.month = selecetdYear[0].number;
    this.getRejtnData();
  }

  //export to excel
  tableToExcel = (function () {
    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>{table}</body></html>'
      , base64 = function (s: any) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s: any, c: any) { return s.replace(/{(\w+)}/g, function (m: any, p: any) { return c[p]; }) }

    return function (table: any, name: string, fileName: any) {
      if (!table.nodeType) table = table
      var ctx = { worksheet: name || 'Worksheet', table: table }
      //window.location.href = uri + base64(format(template, ctx))
      var link = document.createElement("a");
      link.download = fileName || 'download.xls';
      link.href = uri + base64(format(template, ctx));
      link.click();
    }
  })()

  getRejtnData() {
    debugger
      let jarvis: any = this.apiService.getCookie('Jarvis');
      if (jarvis) {
        this.jarvisData = JSON.parse(jarvis);
      }
      
      let agencyData = this.apiService.getCookie('M');
      if (agencyData) {
        this.agencyData = JSON.parse(agencyData);
      }
      
      let data = [
        {
          Year: this.view.year,
          Month: this.view.month,
         
        },
      ];
      let myParams = [
        {
          myUserID: this.jarvisData[0].UserID,
          myToken: this.jarvisData[0].WebToken,
          forAgencyID: this.jarvisData[0].AgencyIDs,
          myAgencyIDs: this.jarvisData[0].AgencyIDs,
          myLastSyncDT: null,
          isWeb: true,
          ForERPAgencyID: this.agencyData[0].ERPAgencyID,
          actionType: 'getPrdRejAnalysis',
          moduleID: 8,
          data: JSON.stringify(data),
        },
      ];
      this.SpinnerService.show();
      this.apiService.getData(myParams, this.successConsDataResp.bind(this), this.consolitedStockfailureResp.bind(this)
      );
    }
  
    successConsDataResp(res: any) {
      this.SpinnerService.hide();
      if (res.error) {
      }
      else {
        if (res) {
          debugger;
          var total = 0;
          var reponseData = JSON.parse(res.updatePackage);
          if (reponseData.Table[0].ErrCode == 1000) {
            alert(reponseData.Table[0].ErrMsg);
          } else {
            if (reponseData.Table[0].ErrCode == -1) {
              this.rejectionAnaData = reponseData.Table1;

              this.rejectionAnaData.forEach((p: any) => {
                total = total + p.JobsImpacted;
                });

                this.rejectionAnaData.forEach((p: any) => {
                  if(p.JobsImpacted > 0){
                    p.Share = ((p.JobsImpacted * 100)/ total).toFixed(2);
                  }
                  else{
                    p.Share = 0;
                  }
                  });
              this.dataSource.data = this.rejectionAnaData;
              this.dataSource.data = this.dataSource.data.sort((a: any, b: any) => a.RejectionType.localeCompare(b.RejectionType))
              this.exportToExcel = this.rejectionAnaData;
              this.dataSource.sort = this.matSort;
              this.item =  this.dataSource.data;

          }
        }
        
      }
    }
  
  }

  //failureResp - failure handler
  consolitedStockfailureResp(res: any) {
    if (res.error) {
    } else {
      alert(res.message);
    }
    
  }
  
  ngAfterViewInit(): void {
    this.dataSource.sort = this.matSort;
    this.dataSource.paginator = this.paginator;
  }

  typeFilter = (obj: any) => {
    this.period = obj
    this.year = this.curDate.getFullYear();
    this.view.year = this.year;

    if (this.period  == 1) {
      this.type = "MM"
      this.view.year = this.curDate.getFullYear();
      this.view.month = this.curDate.getMonth() + 1;
      this.trasYearChange();
    }

    this.getRejtnData();
  }

  //common search
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

//export to excel
exportToExcelActivities() {
  debugger
      var html = "";
      html += "<table><tr>";
      html += "<th style='text-align: left;'>Rejection Cause Analysis	</th>"
      html += "</table></tr>";
      html += "<table><tr></table></tr>";
      html += "</table></tr>";
      html += "</table></tr>";
      
      html += "<p><b>  Month : </b>"+ this.monthDisplay +  "</p>"
      // Blank Column
      html += "<table><tr></table></tr>";
      html += "<table><tr>";

  var strHeader = ""
  strHeader += "<th style='text-align: left;'>Rejection Type</th>";
  strHeader += "<th style='text-align: right;'>Jobs Impacted</th>";
  strHeader += "<th style='text-align: right;'>Share</th>";
  strHeader += "</tr>"
  html += strHeader;

  var body = "";
  this.exportToExcel.forEach((itemData:any, key:any) => {
    body += "<tr>";
    body += "<td style='text-align: left;'>" + itemData.RejectionType + "</td>";
    body += "<td style='text-align: right;'>" + itemData.JobsImpacted  + "</td>";
    body += "<td style='text-align: right;'>" + itemData.Share  +'%' + "</td>";
  body += "</tr>";
  })

 
  html += body;
  html += "</table>";
  this.tableToExcel(html, 'Sheet1', 'Rejection Cause Analysis');
}

backBtn() {
  // this.router.navigate(['/Stock']);
  this.router.navigate(['/ProductionList']);
}

}
